export const commonStyles = {
  heading: {
    fontWeight: 700,
    lineHeight: 1.2,
  },
  veloxHeading: {
    fontWeight: 800,
    fontSize: { xs: "2.5rem", md: "3.5rem" },
    lineHeight: 1.1,
    letterSpacing: "-0.02em",
  },
  bodyText: {
    fontSize: "1.1rem",
    lineHeight: 1.6,
  },
  solutionText: {
    fontSize: "1.1rem",
    lineHeight: 1.6,
    fontWeight: 600,
  },
  tabLabel: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    width: "100%",
  },
  tabVerticalLine: {
    width: 3,
    height: 24,
    bgcolor: "background.paper",
    borderRadius: 1,
  },
  tabTypography: {
    color: "inherit",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: 1,
    fontSize: { xs: "1rem", md: "1.2rem" },
  },
  tabSx: {
    fontWeight: 600,
    fontSize: { xs: "0.9rem", md: "1rem" },
    textTransform: "none",
    py: { xs: 1, md: 3 },
    px: { xs: 1, md: 4 },
    mb: { xs: 2, md: 0 },
    borderRadius: 2,
    transition: "all 0.3s ease",
    alignItems: "flex-start",
    minHeight: { xs: 30, md: 80 },
    "&.Mui-selected": {
      color: "primary",
    },
    "&:hover": {
      bgcolor: "action.hover",
      transform: "translateX(8px)",
    },
  },
  tabsContainer: {
    "& .MuiTabs-indicator": {
      width: 4,
      borderRadius: 2,
      left: 0,
    },
    "& .MuiTabs-flexContainer": {
      gap: 0,
    },
    "& .MuiTabs-scroller": {
      paddingRight: 2,
    },
  },
  videoSection: {
    flex: { xs: "1", md: "0 0 50%" },
    position: "relative",
    minHeight: { xs: 300, md: 400 },
    bgcolor: "primary.dark",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  contentSection: {
    flex: { xs: "1", md: "0 0 50%" },
    p: { xs: 4, md: 6 },
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textDecoration: "none",
    color: "inherit",
  },
  cardHover: {
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: (theme: any) =>
        `0 16px 48px ${
          theme.palette.mode === "dark" ? "rgba(0,0,0,0.4)" : "rgba(0,0,0,0.15)"
        }`,
    },
  },
};
